import { render, staticRenderFns } from "./LinkProductsModal.vue?vue&type=template&id=50199aea"
import script from "./LinkProductsModal.vue?vue&type=script&lang=js"
export * from "./LinkProductsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports